/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ChatContent from "../chatContent/ChatContent";
import ChatList from "../chatList/ChatList";
import styled from "styled-components";
import { AutoCompleteTexting } from "../adjusterSearch/AutoCompleteTexting";
import { getAllAdjusters } from "../../store/actions/adjusterActions";
import {
  RECEIVED,
  SEND,
  SNACKBAR,
  TEXTING_ACCESS,
} from "../../utils/constants";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { useDispatch, useSelector } from "react-redux";
import fetchConversations, {
  fetchMessagesById,
  fetchUnreadMessagesCountById,
  formatSelectedConversation,
} from "../../store/actions/conversationActions";
//import { useNavigate } from "react-router";
import {
  updateInitialState,
  updateMessagesById,
} from "../../store/action-creators/conversationActionCreator";
import { updateConversationsLoader } from "../../store/action-creators/loaderActionCreators";
import { updateConversationViewerSelectedAdjuster } from "../../store/action-creators/adjusterActionCreator";
import {
  checkAndUpdateConversationListFromNewMessage,
  formatNewLinesInHtml,
  getUpdatedMessages,
  handleSubscriptionError,
  isActiveParticipant,
  setAlert,
  simpleGTMDataLayer,
  twoStringsAreEqual,
  updateConversationsOrder,
} from "../../utils/utilities";
import { executeGraphqlSubscribe } from "../../graphql/api";
import { loader } from "graphql.macro";
import { useNavigate } from "react-router-dom";
const receiveMessagesSubscription = loader(
  "../../graphql/subscriptions/receiveMessagesByAdjusterId.graphql"
);

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  .list {
    flex: 1;
    min-width: 250px;
    .search {
      height: 100px;
      background-color: #3e5572;
      text-align: center;
      padding: 10px;
      .text {
        color: white;
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
      }
    }
  }
  .chat-list {
    height: calc(100% - 200px);
  }
`;


export default function ConversationViewer(props: any) {
  // const [notificationSoundValue] = useGlobalState("notificationSound");
  const [newMessage, setNewMessage] = useState({
    message: "",
    from: { id: "", name: "" },
    createdTime: "",
    conversationId: "",
    adjusterId: "",
  });
  const [adjusters, setAdjusters] = useState([]);
  const selectedAdjuster = useSelector(
    (state: any) => state.adjusters.selectedAdjuster
  );
  const selectedConversation = useSelector(
    (state: any) => state.chat.selectedConversation
  );
  const messages = useSelector((state: any) => state.chat.messagesById);
  const unreadMsgCount = useSelector((state: any) => state.chat.unreadMsgCount);
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const history = useNavigate();
  const [email,setEmail]=useState(user?.email);

  let messageSubscription: any;

  useEffect(() => {
    let conversationId = selectedConversation?.conversationId;
    if (conversationId) {
      history(`/conversation-viewer?id=${conversationId}`);
      if (!(messages && messages[conversationId])) {
        dispatch(fetchMessagesById(conversationId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedConversation]);

  useEffect(() => {
    //subscribe current user's messages
    subscribeToMessage(user?.email);
    simpleGTMDataLayer({
      csrId: user.userName,
      event: "pageview",
      page: {
        path: "/conversation-viewer",
        title: "Claims Texting: Conversation Viewer Page",
      },
    });
    dispatch(updateInitialState());
    return () => {
      dispatch(updateInitialState());
      messageSubscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (newMessage.message) {
      let newMsgDetails: any = {type:"",conversationId:"",fromId:""};
      if (messages[newMessage.conversationId]) {
        let updatedMessages = getUpdatedMessages(newMessage);
         let updatedNewMessage = {
          ...newMessage,
          type: twoStringsAreEqual(user.email, newMessage.from.id)
            ? SEND
            : RECEIVED,
        };
        newMsgDetails = {
          type:updatedNewMessage.type,
          conversationId:newMessage.conversationId,
          fromId:newMessage.from.id
        };
        dispatch(
          updateMessagesById({
            ...messages,
            [newMessage.conversationId]: [
              ...updatedMessages,
              updatedNewMessage
            ]
          })
        );
      }
      else{
        newMsgDetails = {
          type:twoStringsAreEqual(user.email, newMessage.from.id)
          ? SEND
          : RECEIVED,
          conversationId:newMessage.conversationId,
          fromId:newMessage.from.id
        };
      }
    
     if(selectedAdjuster!==null && user.email!==email){
      if (isActiveParticipant(newMessage.conversationId,selectedAdjuster.adjusterEmailId)) {
        dispatch(fetchUnreadMessagesCountById(newMessage.conversationId));
        updateConversationsOrder(newMessage.conversationId);
        setAlert(newMsgDetails);
      }
     }
      else{
        setAlert(newMsgDetails);
      }
    }
  }, [newMessage]);

  const subscribeToMessage = (userId: any) => {
    messageSubscription = executeGraphqlSubscribe(
      receiveMessagesSubscription
    ).subscribe({
      next: ({ provider, value }: any) => {
        let messageResponse = value?.data?.onCreateMessageByAdjusterId;
        if ((messageResponse?.adjusterIds || []).includes(userId)) {
          messageResponse = {
            ...messageResponse,
            message: formatNewLinesInHtml(messageResponse.message),
          };
          setEmail(userId);
          setNewMessage(messageResponse);
          if(selectedAdjuster!==null)
          if(userId===selectedAdjuster.adjusterEmailId ){
          checkAndUpdateConversationListFromNewMessage(
            messageResponse,
            selectedAdjuster.adjusterEmailId
          );
          }
        }
      },
      error: ({ error, provider }: any) => {
        handleSubscriptionError(error);
      },
    });
  };
  
  useEffect(() => {
    if (selectedAdjuster) {
      dispatch(updateConversationsLoader({ isLoading: true }));
      dispatch(updateInitialState());
      //subscribe selected adjuster messages
      subscribeToMessage(selectedAdjuster.adjusterEmailId);
      dispatch(
        fetchConversations(
          { adjusterId: selectedAdjuster?.adjusterEmailId },
          (res: any) => {
            if (res.length > 0) {
              dispatch(formatSelectedConversation(res[0]));
            }
            dispatch(updateConversationsLoader({ isLoading: false }));
          }
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAdjuster]);

  const handleChange = (value: any) => {
    getAllAdjusters({ query: value ,adjusterRoles:[TEXTING_ACCESS]})
      .then((res: any) => {
        let adjustersList = res.data && res.data && res.data.searchAdjuster;
        let updatedList = adjustersList.map((user: any) => {
            return {
              adjusterName: user.adjuster_name?.replace(/- /g, ""),
              adjusterEmailId: user.contact_email?.toLowerCase(),
            };
          });
        setAdjusters(updatedList);
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          snackbarOpen({
            open: true,
            message: error.message,
            type: SNACKBAR.ERROR,
          })
        );
      });
  };
  const handleSelect = (index: any) => {
    let filterAdjuster:any =adjusters.filter((adj:any)=>{
      return adj.adjusterEmailId !== user.email
  });
    let adjuster: any = filterAdjuster[index];
    messageSubscription?.unSubscribe();
    dispatch(updateConversationViewerSelectedAdjuster(adjuster));
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Conversation-Viewer-Search-Adjuster`,
      event_action: "Searching for adjuster",
      event_category: window.location.pathname,
      event_label: `User can try to view other adjuster Conversations`,
      event_value: `${user.fullName} searching for ${adjuster.adjusterName} conversations.`,
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Conversation-Viewer-Search-Adjuster-SnowPlow`,
      event_action: "Searching for adjuster",
      event_category: window.location.pathname + "/Snowplow",
      event_label: `User can try to view other adjuster Conversations`,
      event_value: `${user.fullName} searching for ${adjuster.adjusterName} conversations.`,
    });
  };

  const getAdjusterNames = () => {
    return adjusters
      .filter((adjuster: any) => {
        return adjuster.adjusterEmailId !== user.email;
      })
      .map((adjuster: any) => {
        return adjuster.adjusterName;
      });
  };

  return (
    <Wrapper>
      <div className="list">
        <div className="search">
          <div className="text">View Conversations For:</div>
          <AutoCompleteTexting
            id="adjusters"
            variant="search"
            options={getAdjusterNames()}
            placeholder="Select an Adjuster"
            onChange={(e: any) => handleChange(e.currentTarget.value)}
            listHeight={20}
            value={selectedAdjuster?.adjusterName || ""}
            onSelect={(index: number) => handleSelect(index)}
          />
        </div>
        <ChatList isViewer={true} menuOptions={false} />
      </div>
      <ChatContent readOnly={true} />
    </Wrapper>
  );
}
